import { render, staticRenderFns } from "./searchEmployees.vue?vue&type=template&id=0a23df10"
import script from "./searchEmployees.vue?vue&type=script&lang=js"
export * from "./searchEmployees.vue?vue&type=script&lang=js"
import style0 from "./searchEmployees.vue?vue&type=style&index=0&id=0a23df10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports